import React from 'react'
import Layout from '../../Layout'
import AllOrderContainer from '../../../../Components/OrdersPart/AllOrderContainer/AllOrderContainer'

const AllOrder = () => {
  return (
    <Layout>
      <AllOrderContainer/>
    </Layout>
  )
}

export default AllOrder